<script>
    import { DateTime } from 'luxon';
    import { User } from '../store.js';
    import Property from '../components/Property.svelte';
    import fetchNodeProduction from "../helpers/FetchNodeProduction";

    export let properties = [];
    export let dateRange = {};
    export let limit;
    export let page;
    export let availability;

	var dateHeader=-1;

	let user;
	let showPrices = false;
  let markupPercentage = 15;
	const unUser = User.subscribe(v => user = v);

    const isWeekend = date => date.weekday === 4 || date.weekday === 5;

    fetchNodeProduction('/getChannelSettings?filter={"id":99}', null, 'GET')
      .then(res => {
        if (res.data && res.data.length > 0) {
          markupPercentage = parseFloat(res.data[0].markupPercentage) > 0 ? parseFloat(res.data[0].markupPercentage) : 15;
        }
      });

    let offset = 0;

	$: grid = generateGrid(dateRange,offset);
	$: _properties = properties.filter((value,key) => key < page * limit && key >= (page-1) * limit);

	function getRangeSize(dateRange,offset){
		const startDate = DateTime.fromJSDate(dateRange.start).plus({days:offset});
		const endDate = DateTime.fromJSDate(dateRange.end);
		return endDate.diff(startDate,'days').toObject().days;
	}

    function generateGrid(dateRange,offset){
    	const date = DateTime.fromJSDate(dateRange.start).plus({days:offset});
    	const diff = getRangeSize(dateRange,offset);
		const gridSize = Math.floor((document.body.clientWidth-16-62-322) / 51);
		let grid = [];
		for(let i = 0;i <= diff && i < gridSize;i++){
			grid.push({ date : date.plus({days: i}) })
		}
		return grid;
	}

	function findPosY(e) {
	  var top = 0;
	  if (e.offsetParent && typeof (e.offsetParent) != 'undefined') {
	    while (e.offsetParent) {
	      top += e.offsetTop;
	      e = e.offsetParent;
	    }
	    top += e.offsetTop;
	  }
	  else if (e.y)
	    top += e.y;
	  return top;
	}

	window.onscroll=function(){
		try {
			var header = document.getElementById('date-header');
			if(dateHeader<0)dateHeader=findPosY(header);

			if(window.pageYOffset>dateHeader){
				header.style.position='fixed';
				header.style.zIndex='5';
				header.style.top=0;
			} else {
				header.style.position='relative';
				header.style.zIndex='auto';
			}
		} catch (ex){
			console.log("not using on scroll")
		}
	};
</script>
<svelte:window on:resize={() => grid = generateGrid(dateRange,offset)} />
<div class='row'>
	{#if user.accountRole.toLowerCase() === 'cleaner'}
		<div class='legend cleaner'>
			<span class='checkout'>Check-out</span>
			<span class='deepclean'>Deep Clean</span>
			<span class='midstay'>Mid Stay</span>
			<span class='touchup'>Touch Up</span>

		</div>
	{:else}
		<div class='legend'>
			<span class='available'>Available</span>
			<span class='booked'>Booked</span>
			<span class='blocked'>Blocked</span>
			<span class='hostBooking'>Host Booking</span>
		</div>
	{/if}

	{#if grid.length}
	<div class='range-nav'>
		<button disabled={offset < 1} on:click={() => offset--} >&#10094;</button>
		<div class='range'>
			{grid[0].date.toLocaleString({ month: 'long', day: 'numeric', year: 'numeric' })} -
			{grid[grid.length-1].date.toLocaleString({ month: 'long', day: 'numeric', year: 'numeric' })}
		</div>
			<button disabled={grid.length > getRangeSize(dateRange,offset)} on:click={() => offset++} >&#10095;</button>
	</div>
	{/if}
	{#if user.airbetterRoleId === 1}
	<div class='legend price'>
		<span class='showPrices' class:active='{showPrices}' on:click={() => showPrices = !showPrices}>Show Prices</span>
	</div>
	{/if}
</div>
{#if _properties.length > 0}
	<div class='date-header' id='date-header'>
	{#each grid as cell}
		<div class='date' class:isWeekend='{isWeekend(cell.date)}'>
			<p>{cell.date.weekdayShort}</p>
			<p>{cell.date.day}/{cell.date.month}</p>
		</div>
	{/each}
	</div>
{/if}
<div class='properties' class:showPrices='{showPrices}'>
	{#each _properties as property, i}
    <Property property={property} dateRange={dateRange} grid={grid} availability={availability} markupPercentage={markupPercentage} />
	{/each}
</div>
<style>
	.row{
		display:flex;
	}
	.legend{
		display: flex;
	}
	.legend span{
		margin-right: 10px;
		font-size: 14px;
		line-height: 19px;
		font-weight: bold;
		color:#66615B;
	}
	.legend.price span{
		cursor:pointer;
	}
	.legend.price span.active::before{
		background-color: #EF4064;
	}
	.legend.cleaner span{
		line-height: 25px;
	}
	.legend.cleaner span::before{
		border:none;
		background-color: #EF4064;
		width:25px;
		height:25px;
		background-position: center;
		background-repeat:no-repeat;
	}

	.legend.cleaner span.midstay::before{
		border:none;
		background-color: #42ACAD;
		background-image: url(/img/midstay_sm.png);
	}


	.legend.cleaner span.touchup::before{
		border:none;
		background-color: #42ACAD;
		background-image: url(/img/touch-up_sm.png);
	}
	.legend.cleaner span.deepclean::before{
		border:none;
		background-color: #EF4064;
		background-image: url(/img/deep-clean_sm.png);
	}
	.legend.cleaner span.checkout::before{
		border:none;
		background-color: #EF4064;
		background-image: url(/img/checkout_sm.png);
	}


	.legend span::before{
		content: '';
		border:1px solid #444;
		width:15px;
		height: 15px;
		display: block;
		float:left;
		margin-right:5px;
	}
	.legend span.blocked::before{
		background-color: #D0CECF;
	}
	.legend span.booked::before{
		background-color: #F04066;
	}
	.legend span.hostBooking::before{
		border: 2px solid red;
		background-color: white;
	}

	.range-nav{
		flex-grow:1;
		align-items: center;
  		justify-content: center;
		margin-bottom: 15px;
		font-size:14px;
		text-align: center;
		display: flex;
	}
	.range{
		min-width: 260px
	}
	.date-header{
		display:flex;
		padding-left:320px;
		border-top:1px solid #ddd;
		border-left: 1px solid #ddd;
		border-bottom: 1px solid #ddd;
		width:fit-content;
		position: relative;
		top: 0px;
		background-color: white;
	}
	.date:first-child{
		border-left: 1px solid #ddd;
	}
	.date{
		border-right: 1px solid #ddd;
		width: 50px;
		height: 46px;
		font-size:12px;
		text-align: center;
		padding:4px 0 0;
	}
	.date.isWeekend{
		background-color: #FDE9EB;
	}
	.date p{
		margin:4px 0;
	}
</style>
